import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export const formatDate = (date: Date, options?: Intl.DateTimeFormatOptions) => {
  return new Intl.DateTimeFormat('pt-BR', options).format(date)
}

export const convertDateString = (date: string, separator: string = '/') => {
  const dateInISOFormat = date.split(separator).reverse().join('-')
  return new Date(dateInISOFormat)
}

export const getRelativeTimeFromNow = (
  date: string | number | Date | dayjs.Dayjs | null | undefined
) => {
  return dayjs(date).fromNow()
}

/** Adiciona dias úteis (seg–sex) a uma data "YYYY-MM-DD". */
export const addBusinessDays = (dateStr: string, days: number): string => {
  if (!dateStr) return ''

  const date = new Date(dateStr)
  let addedDays = 0

  while (addedDays < days) {
    date.setDate(date.getDate() + 1)
    const day = date.getDay()

    if (day !== 0 && day !== 6) {
      addedDays++
    }
  }

  return date.toISOString().split('T')[0]
}
